// ============================================================================
// CALENDAR MCP SERVICE
// Frontend API client for the personal, platform-level calendar MCP token.
// Separate from the per-project MCP config (services used by McpServerTab).
// ============================================================================

import { api } from './api';

export interface UserMcpConfig {
  mcpEnabled: boolean;
  hasToken: boolean;
  mcpTokenHint?: string;
  mcpWriteEnabled: boolean;
}

export async function getUserMcpConfig(): Promise<UserMcpConfig> {
  const res = await api.get('/api/users/mcp-config');
  return res.data;
}

export async function enableUserMcp(): Promise<{ token: string; mcpTokenHint: string }> {
  const res = await api.post('/api/users/mcp-config/enable');
  return res.data;
}

export async function regenerateUserMcpToken(): Promise<{ token: string; mcpTokenHint: string }> {
  const res = await api.post('/api/users/mcp-config/regenerate');
  return res.data;
}

export async function disableUserMcp(): Promise<void> {
  await api.post('/api/users/mcp-config/disable');
}

export async function setUserMcpWriteEnabled(enabled: boolean): Promise<void> {
  await api.post(`/api/users/mcp-config/write/${enabled ? 'enable' : 'disable'}`);
}
